import React from "react";
import { Form, Table } from "react-bootstrap";
import { useIntl } from "react-intl";
import { IStepsList } from "src/app/components/form/FormikStepper";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import { SimpleFormTextarea } from "src/app/components/form/SimpleFormTextarea";
import Pacman from "src/app/components/layout/Pacman";
import { UpsertNumberOfTextsSchema } from "src/app/types/BoostSilo";
import { ISemRushKeywords } from "src/app/types/semrush";

export const SiloStepsList = (
    selectedKeywords: string[],
    handleSelectedKeyword: (keywords: string) => void,
    keywords: ISemRushKeywords[],
    loading: boolean,
    error?: string
): IStepsList[] => {
    const { formatMessage } = useIntl();
    const price = process.env.REACT_APP_KEYWORDS_AUTO_AI_PRICE;

    return [
        {
            title: `${formatMessage({ id: "common.stepper.numberOfText" })}`,
            api: "numberOfSilo",
            element: (
                <div className="d-flex h-100 align-items-center justify-content-center">
                    <SimpleFormControl
                        name="numberOfTexts"
                        type="number"
                        label={formatMessage({ id: "common.field.howManySilo" })}
                    />
                </div>
            ),
            validationSchema: UpsertNumberOfTextsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.semRushKeywords" })}`,
            api: "semRushKeywords",
            element: (
                <>
                    {!loading ? (
                        <>
                            {error ? (
                                <>{error}</>
                            ) : (
                                <div className="siloWrapperTable">
                                    <div className="d-flex justify-content-end mt-2 p-2 bg-light rounded">
                                        <div className="selected-keywords-counter">
                                            <strong>
                                                {formatMessage(
                                                    { id: "common.text.totalKeywords" },
                                                    { count: selectedKeywords.length }
                                                )}{" "}
                                                ({selectedKeywords.length}/{keywords.length})
                                            </strong>
                                            <span className="badge bg-primary ms-2">
                                                {selectedKeywords.length}
                                            </span>
                                            <div className="d-flex flex-column text-end">
                                                <strong>
                                                    {formatMessage({
                                                        id: "common.text.totalprice",
                                                    })}
                                                    :{" "}
                                                    {new Intl.NumberFormat("de-DE", {
                                                        style: "currency",
                                                        currency: "EUR",
                                                    }).format(
                                                        selectedKeywords.length *
                                                            parseFloat(price || "0")
                                                    )}
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                    <Table bordered>
                                        <thead>
                                            <tr
                                                className={"header-no-Selected"}
                                                onClick={() =>
                                                    handleSelectedKeyword(
                                                        selectedKeywords.length === keywords.length
                                                            ? "REMOVE_KEYWORDS"
                                                            : "ALL_KEYWORDS"
                                                    )
                                                }
                                            >
                                                <th>
                                                    <Form.Check
                                                        type="switch"
                                                        checked={
                                                            selectedKeywords.length ===
                                                            keywords.length
                                                        }
                                                    />
                                                </th>
                                                <th>
                                                    {formatMessage({
                                                        id: "common.field.keywords",
                                                    })}
                                                </th>
                                                <th>
                                                    {formatMessage({
                                                        id: "common.field.volume",
                                                    })}
                                                </th>
                                                <th>
                                                    {formatMessage({
                                                        id: "common.field.price",
                                                    })}
                                                </th>
                                                <th>
                                                    {formatMessage({
                                                        id: "common.field.keywordDifficultyIndex",
                                                    })}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {keywords?.map((keywordsData, index) => (
                                                <tr
                                                    key={index}
                                                    onClick={() =>
                                                        handleSelectedKeyword(
                                                            keywordsData.keyword || ""
                                                        )
                                                    }
                                                    className={
                                                        selectedKeywords.includes(
                                                            keywordsData.keyword || ""
                                                        )
                                                            ? "selected"
                                                            : ""
                                                    }
                                                >
                                                    <td>
                                                        <Form.Check
                                                            type="switch"
                                                            checked={selectedKeywords.includes(
                                                                keywordsData.keyword || ""
                                                            )}
                                                            onChange={() => {}}
                                                        />
                                                    </td>
                                                    <td>{keywordsData.keyword}</td>
                                                    <td>{keywordsData.volume}</td>
                                                    <td>
                                                        {new Intl.NumberFormat("de-DE", {
                                                            style: "currency",
                                                            currency: "EUR",
                                                        }).format(parseFloat(price || "0"))}
                                                    </td>
                                                    <td>{keywordsData.keywordDifficultyIndex}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>{" "}
                                </div>
                            )}
                        </>
                    ) : (
                        <Pacman />
                    )}
                </>
            ),
            validationSchema: UpsertNumberOfTextsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.userKeywords" })}`,
            api: "userKeywords",
            element: (
                <>
                    <div className="d-flex justify-content-end mt-2 p-2 bg-light rounded">
                        <div className="selected-keywords-counter">
                            <span className="badge bg-primary me-2">{selectedKeywords.length}</span>
                            <strong>
                                {formatMessage(
                                    { id: "common.text.totalKeywords" },
                                    { count: selectedKeywords.length }
                                )}{" "}
                                ({selectedKeywords.length}/{keywords.length})
                            </strong>
                            <div className="d-flex flex-column text-end">
                                <strong>
                                    {formatMessage({
                                        id: "common.text.totalprice",
                                    })}
                                    :{" "}
                                    {new Intl.NumberFormat("de-DE", {
                                        style: "currency",
                                        currency: "EUR",
                                    }).format(selectedKeywords.length * parseFloat(price || "0"))}
                                </strong>
                            </div>
                        </div>
                    </div>
                    <SimpleFormTextarea
                        name="userKeywords"
                        rows={20}
                        label={formatMessage({ id: "common.field.userKeywords" })}
                    />
                </>
            ),
            validationSchema: UpsertNumberOfTextsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.orderInfo" })}`,
            api: "orderInfo",
            element: (
                <>
                    <ul>
                        {selectedKeywords.map((keyword, index) => {
                            return <li key={index}>{keyword}</li>;
                        })}
                    </ul>
                </>
            ),
            validationSchema: UpsertNumberOfTextsSchema,
        },
    ];
};
